exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".logo-pos-2[data-v-5d3e4f51]{top:40px;left:35px}.login-pos-3[data-v-5d3e4f51]{top:70px;left:35px}.taller[data-v-5d3e4f51]{height:110px}.jelly-button[data-v-5d3e4f51]{cursor:pointer;display:block;width:90px}", ""]);
